import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import React, { useState } from "react";
import {
	Button,
	Confirm,
	useNotify,
	useRefresh,
	useTranslate,
	useUnselectAll,
	useUpdateMany,
} from "react-admin";

const ResetAttemptsButton = ({ selectedIds }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const refresh = useRefresh();
	const unselectAll = useUnselectAll();
	const [isOpen, setIsOpen] = useState(false);
	const [updateMany, { loading }] = useUpdateMany(
		"bookmaker-approvals",
		selectedIds,
		{ attempts: 3 },
		{
			onSuccess: () => {
				notify(
					translate(
						`resources.bookmaker-approvals.actions.reset_attempts.sucess`
					)
				);
				unselectAll("bookmaker-approvals");
				refresh();
				handleClose();
			},
			onError: () => {
				notify(
					translate(
						"resources.bookmaker-approvals.actions.reset_attempts.error"
					)
				);
			},
		}
	);

	const handleClose = () => setIsOpen(false);
	const handleOpen = () => setIsOpen(true);

	return (
		<>
			<Confirm
				isOpen={isOpen}
				loading={loading}
				title={translate(
					"resources.bookmaker-approvals.actions.reset_attempts.title"
				)}
				content={translate(
					"resources.bookmaker-approvals.actions.reset_attempts.content"
				)}
				onConfirm={updateMany}
				onClose={handleClose}
			/>
			<Button
				onClick={handleOpen}
				label={translate("resources.user-payments.buttons.reset_attempts")}
			>
				<RotateLeftIcon />
			</Button>
		</>
	);
};

export default ResetAttemptsButton;
